module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6SYJI"))).then(() => parcelRequire('cvs7o'));